import $ from "jquery";

const $newsletterSignupForm = $(".js-newsletter-signup-form");
if ($newsletterSignupForm.length) {
    $newsletterSignupForm.on("submit", async function (e) {
        e.preventDefault()
        const { method, action } = this
        const $this = $(this)
        const $emailInput = $this.find("input[name='email']")
        const email = $emailInput.val()
        $.ajax({
            method,
            url: action,
            data: { email },
            success: function () {
                $this.addClass("d-none")
                $this.siblings('.js-newsletter-signup-success-message').removeClass("d-none")
            },
            error: function (response) {
                console.warn(response)
                if (response.responseJSON) {
                    const {
                        responseJSON: { message, status },
                    } = response
                    alert(`${status}: ${message}`)
                }
            },
        })
    })

    if (localStorage.getItem('isPurchasing') ) {
        // Show modal
        localStorage.removeItem('isPurchasing')
    }
}